import root from 'window-or-global';

const authTimers = {};

const getAuthTimer = platform => {
    return authTimers[platform];
};

const removeAuthPopupListener = platform => {
    clearInterval(getAuthTimer(platform));
    authTimers[platform] = null;
};

export const clearAuthPopupListener = () => {
    Object.keys(authTimers).forEach(key => removeAuthPopupListener(key));
};

export const onResizePopupListener = popup => {
    try {
        if (!popup || popup.closed) return;

        const resizePop = popup => {
            if (popup.outerWidth < 516 || popup.outerHeight < 700) {
                popup.resizeTo(516, 700);
            }
        };

        popup.addEventListener(
            'resize',
            function(event) {
                resizePop(this);
            },
            true
        );

        resizePop(popup);
    } catch (err) {
        console.error('Failed to add resize event');
    }
};

const onClosePopupListener = (popup, platform) => {
    authTimers[platform] = setInterval(() => {
        if (!popup.closed) return;
        /*global CustomEvent*/
        root.document.dispatchEvent(
            new CustomEvent('closeAuthPopup', {
                bubbles: true,
                detail: {
                    platform
                }
            })
        );
        removeAuthPopupListener(platform);
    }, 250);
};

export const listenAuthPopup = (popup, platform) => {
    // setTimeout(() => {
    //     /*global CustomEvent*/
    //     root.document.dispatchEvent(
    //         new CustomEvent('openAutoPopup', {
    //             bubbles: true,
    //             detail: {
    //                 platform
    //             }
    //         })
    //     );
    // }, 200);

    onClosePopupListener(popup, platform);
};
